module.exports = __webpack_public_path__ + "static/media/investor-scout-3-logo.7d5eb51c.svg";